<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app',
  async created() {
    try {
      await this.$auth.renewTokens();
    } catch {
      // Supress the 'not logged in' error as we can illegitimately get that
      // when processing the callback url
    }
  }
}
</script>

<style lang="scss">
  // common application styles
  @import 'assets/scss/style';
</style>
